const LOGO_URL = 'https://static.readdy.ai/image/8c1d21b01113fd26c1c387000dbd0877/4317f3ce3a0bbec34cf488c9c5fe026b.png';

export default function Footer() {
  return (
    <footer className="py-14" style={{ background: '#1C2B3A' }}>
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 mb-10">
          {/* Brand */}
          <div>
            <div className="mb-4">
              <img
                src={LOGO_URL}
                alt="신진패키징 로고"
                className="h-12 w-auto object-contain brightness-0 invert"
              />
            </div>
            <p className="text-gray-400 text-sm leading-relaxed mb-5 max-w-xs">
              농산물 패키징 실무를 해결하는 B2B 전문 기업입니다. 플라스틱 팩 공급부터 라벨 디자인, 부착 서비스까지 원스톱으로 제공합니다.
            </p>
            <div className="text-xs text-gray-500">
              플라스틱 포장용기, 각종 포장재(종이·부직포·띠지)
            </div>
          </div>

          {/* Contact */}
          <div>
            <div className="text-sm font-bold uppercase tracking-widest text-gray-500 mb-5">CONTACT</div>
            <div className="flex flex-col gap-4">
              {[
                { icon: 'ri-phone-line', text: '010-7702-3283', sub: '영업 문의', href: 'tel:01077023283' },
                { icon: 'ri-printer-line', text: '0504-158-3283', sub: '팩스', href: '#' },
                { icon: 'ri-mail-line', text: 'clxk0711@gmail.com', sub: '이메일', href: 'mailto:clxk0711@gmail.com' },
                { icon: 'ri-map-pin-line', text: '경기 성남시 분당구 서현동 249-3 6층', sub: '주소', href: 'https://maps.google.com/?q=경기+성남시+분당구+서현동+249-3' },
              ].map((c) => (
                <a key={c.text} href={c.href} rel="nofollow" className="flex items-start gap-3 group cursor-pointer">
                  <div className="w-8 h-8 flex items-center justify-center rounded-lg flex-shrink-0 mt-0.5" style={{ background: 'rgba(43,192,208,0.15)' }}>
                    <i className={`${c.icon} text-base`} style={{ color: '#2BC0D0' }} />
                  </div>
                  <div>
                    <div className="text-xs text-gray-500 mb-0.5">{c.sub}</div>
                    <div className="text-base text-gray-300 group-hover:text-white transition-colors">{c.text}</div>
                  </div>
                </a>
              ))}
            </div>
          </div>

          {/* Links */}
          <div>
            <div className="text-sm font-bold uppercase tracking-widest text-gray-500 mb-5">QUICK LINKS</div>
            <div className="flex flex-col gap-3">
              {[
                { label: '핵심 서비스', id: 'services' },
                { label: '고객 유형 안내', id: 'customer-type' },
                { label: '제품 구매 (스마트스토어)', id: 'smartstore' },
                { label: '진행 프로세스', id: 'process' },
                { label: '납품 사례', id: 'cases' },
              ].map((link) => (
                <button
                  key={link.id}
                  onClick={() => {
                    const el = document.getElementById(link.id);
                    if (el) el.scrollIntoView({ behavior: 'smooth' });
                  }}
                  className="text-base text-gray-400 hover:text-white transition-colors cursor-pointer text-left whitespace-nowrap"
                >
                  {link.label}
                </button>
              ))}
              <a
                href="https://smartstore.naver.com"
                target="_blank"
                rel="nofollow noreferrer"
                className="inline-flex items-center gap-1.5 text-base font-bold cursor-pointer whitespace-nowrap mt-1 transition-opacity hover:opacity-80"
                style={{ color: '#2BC0D0' }}
              >
                스마트스토어 바로가기
                <i className="ri-external-link-line text-sm" />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="pt-8 border-t border-gray-700/50 flex flex-col md:flex-row items-center justify-between gap-3">
          <div className="text-sm text-gray-500">
            &copy; 2026 (주)신진패키징. All rights reserved.
          </div>
          <div className="flex gap-4">
            <a href="#" rel="nofollow" className="text-sm text-gray-500 hover:text-gray-400 transition-colors cursor-pointer">이용약관</a>
            <a href="#" rel="nofollow" className="text-sm text-gray-500 hover:text-gray-400 transition-colors cursor-pointer">개인정보처리방침</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
